import { ModelBase } from "./ModelBase";

export class PianoPrevisionaleIntestazione extends ModelBase {
    Anno: number;
    Cliente: string;
    FatturoPrevisto: number;
    IncassatoPrevisto: number;
    CostiFissiPercentuale: number;
    CostiVariabiliPercentuale: number;
}

export class ElencoPianiPrevisionaliModel extends ModelBase {
    ListaPiano: PianoPrevisionaleIntestazione[];
}

export class PianoPrevisionaleOptions {
    Anno: number;
    Cliente: string;
    FatturoPrevisto: number;
    IncassatoPrevisto: number;
    CostiFissiPercentuale: number;
    CostiVariabiliPercentuale: number;
    PianoId: string
}

export class PianoPrevisionaleDetailsModel extends ModelBase{
    Elements: PianoPrevisionaleReport[]
}

export class PianoPrevisionaleReport extends ModelBase{
    Descrizione : string
    Gennaio: number
    Febbraio: number
    Marzo: number
    Aprile: number
    Maggio: number
    Giugno: number
    Agosto: number
    Settembre: number
    Ottobre: number
    Novembre: number
    Dicembre: number
}